import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

/* ---------------- Categories ------------------- */

export const categorySave: TypedDocumentNode<Pick<GQL.IMutation, "categorySave">, GQL.IMutationCategorySaveArgs> = gql`
    mutation categorySave($input: CategorySaveInput!) {
        categorySave(input: $input) {
            id
            name
        }
    }
`;
export const categoryDelete: TypedDocumentNode<
    Pick<GQL.IMutation, "categoryDelete">,
    GQL.IMutationCategoryDeleteArgs
> = gql`
    mutation categoryDelete($input: CompanyNumEntityDeleteInput!) {
        categoryDelete(input: $input)
    }
`;

/* ---------------- Creditors ------------------- */

export const creditorCreate: TypedDocumentNode<
    Pick<GQL.IMutation, "creditorCreate">,
    GQL.IMutationCreditorCreateArgs
> = gql`
    mutation creditorCreate($input: CredDebCreateInput!) {
        creditorCreate(input: $input) {
            id
            name
        }
    }
`;

export const creditorUpdate: TypedDocumentNode<
    Pick<GQL.IMutation, "creditorUpdate">,
    GQL.IMutationCreditorUpdateArgs
> = gql`
    mutation creditorUpdate($input: CredDebUpdateInput!) {
        creditorUpdate(input: $input) {
            id
            name
        }
    }
`;

export const creditorDelete: TypedDocumentNode<
    Pick<GQL.IMutation, "creditorDelete">,
    GQL.IMutationCreditorDeleteArgs
> = gql`
    mutation creditorDelete($input: CompanyNumEntityDeleteInput!) {
        creditorDelete(input: $input)
    }
`;

/* ---------------- Debitors ------------------- */

export const debitorCreate: TypedDocumentNode<
    Pick<GQL.IMutation, "debitorCreate">,
    GQL.IMutationDebitorCreateArgs
> = gql`
    mutation debitorCreate($input: CredDebCreateInput!) {
        debitorCreate(input: $input) {
            id
            name
        }
    }
`;

export const debitorUpdate: TypedDocumentNode<
    Pick<GQL.IMutation, "debitorUpdate">,
    GQL.IMutationDebitorUpdateArgs
> = gql`
    mutation debitorUpdate($input: CredDebUpdateInput!) {
        debitorUpdate(input: $input) {
            id
            name
        }
    }
`;

export const debitorDelete: TypedDocumentNode<
    Pick<GQL.IMutation, "debitorDelete">,
    GQL.IMutationDebitorDeleteArgs
> = gql`
    mutation debitorDelete($input: CompanyNumEntityDeleteInput!) {
        debitorDelete(input: $input)
    }
`;

/* ---------------- Tags ------------------- */

export const tagCreate: TypedDocumentNode<Pick<GQL.IMutation, "tagCreate">, GQL.IMutationTagCreateArgs> = gql`
    mutation tagCreate($input: TagCreateInput!) {
        tagCreate(input: $input) {
            id
            name
        }
    }
`;

export const tagUpdate: TypedDocumentNode<Pick<GQL.IMutation, "tagUpdate">, GQL.IMutationTagUpdateArgs> = gql`
    mutation tagUpdate($input: TagUpdateInput!) {
        tagUpdate(input: $input) {
            id
            name
        }
    }
`;

export const tagDelete: TypedDocumentNode<Pick<GQL.IMutation, "tagDelete">, GQL.IMutationTagDeleteArgs> = gql`
    mutation tagDelete($input: CompanyNumEntityDeleteInput!) {
        tagDelete(input: $input)
    }
`;

export const genericRecordTextTemplateSave: TypedDocumentNode<
    Pick<GQL.IMutation, "genericRecordTextTemplateSave">,
    GQL.IMutationGenericRecordTextTemplateSaveArgs
> = gql`
    mutation genericRecordTextTemplateSave($input: GenericRecordTextTemplateSaveInput!) {
        genericRecordTextTemplateSave(input: $input) {
            id
            companyId
            text
            type
            productIds
        }
    }
`;
